import React, {Component} from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core'
import {Add, ArrowDownward, ArrowUpward, Delete} from '@material-ui/icons'
import _ from 'lodash'
import localization from '../../../config/localization';
import {getStoredUser, ROLES} from '../../../api-client/core/authentication/utils';
import AsyncSelect from 'react-select/lib/Async'
import {request} from '../../../api-client';
import GlobalSnackbar, {GlobalSnackbarTypes} from '../../../components/Letflow/Snackbar/GlobalSnackbar';
import {makeFitImageUrlWithSize, validateEmail} from '../../../utils';
import ProfileImage from "../../../components/Letflow/ProfileImage";
import {get} from 'lodash';

class ParticipantsButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // add participant
      showDialog: false,
      addingParticipant: false,
      participantToBeAdded: null,
      participantToBeAddedIsAdmin: false,
      addParticipantByEmail: false,
      emailOfParticipantTobeAdded: '',
      users: [],
      selectedUsers: [],
      participants: this.props.participants || [],

      // delete participant
      showDeleteDialog: false,
      participantToBeRemoved: null,

      // promote participant
      showPromotionDialog: false,
      participantToBePromoted: null,
      promotionType: 'promote', // or 'demote'

      // component
      submitting: false,
    };
  }

  requestPitch = () =>
     request.pitch.show(this.props.pitchId)
       .then(res => this.setState({participants: res.participants}))

  participantIsFlowlikeAdmin = participant => participant.role_id === ROLES.SUPERVISOR || participant.role_id === ROLES.SYS_ADMIN;

  myUserIsAdminInPitch = () => this.participantIsAdmin(getStoredUser());

  participantIsAdmin = participant => {
    const user = this.state.participants.find(x => x.id === participant.id);
    return user !== undefined && user.pivot && user.pivot.is_admin
  };

  renderParticipantGroup = (groupName, users) =>
    <div style={{ marginBottom: 10 }}>
      <div><b>{groupName}</b></div>
      {users.length === 0 && '-'}
      {users.map(this.renderParticipant)}
    </div>

  renderParticipant = user => {
    const isSelf = user.id === getStoredUser().id;

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} key={user.id}>
        <span>
          <ProfileImage entity={user} default={user.image} />
          {user.name || user.label}
        </span>
        <div>
          {!this.participantIsFlowlikeAdmin(user) &&
            <IconButton onClick={() => {
              this.setState({
                showPromotionDialog: true,
                participantToBePromoted: user,
                promotionType: this.participantIsAdmin(user) ? 'demote' : 'promote'
              })
            }} disabled={isSelf || !this.myUserIsAdminInPitch} >
              {this.participantIsAdmin(user) ? <ArrowDownward /> : <ArrowUpward />}
            </IconButton>}
          <IconButton
            onClick={() => this.setState({ showDeleteDialog: true, participantToBeRemoved: user })}
            disabled={isSelf || !this.myUserIsAdminInPitch}
          >
            <Delete />
          </IconButton>
        </div>
      </div>
    )
  };

  render = () =>
    <React.Fragment>
      {/* the participants dialogs */}
      <this.ParticipantsDialog />
      <this.RemoveParticipantDialog />
      <this.PromoteParticipantDialog />
    </React.Fragment>

  ParticipantsDialog = () =>
    <Dialog open={this.props.open} onBackdropClick={() => this.props.handleClose()} onEscapeKeyDown={() => this.props.handleClose()}>
      <DialogTitle style={{ width: 500, maxWidth: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ marginRight: 10 }}>{localization.get('participants')}</span>
          {!this.state.addingParticipant && <IconButton onClick={() => this.setState({ addingParticipant: true })} disabled={this.state.addingParticipant}><Add /></IconButton>}
        </div>
      </DialogTitle>
      <DialogContent style={{height: "67vh"}}>
        {this.state.addingParticipant ? <this.ParticipantsDialogAddingParticipantContent /> : <this.ParticipantsDialogContent />}
      </DialogContent>
      <DialogActions>
        {this.state.addingParticipant ? <this.ParticipantsDialogAddingParticipantActions /> : <this.ParticipantsDialogActions />}
      </DialogActions>

    </Dialog>

  ParticipantsDialogContent = () =>
    <div style={{marginBottom: 15}}>
      {this.renderParticipantGroup(localization.get('users'), this.state.participants)}
    </div>

  ParticipantsDialogAddingParticipantContent = () =>
    <React.Fragment>
      <p>{localization.get('pitch.add_new_user_instructions')}</p>
      <br />
      <div style={{ height: 250, display: 'flex', marginTop: 10 }}>
        {/** Select New Participant */}
        <div style={{ flex: 9 }}>
          <this.NewParticipantSelectionInput />
        </div>
        {/** Check if new Participant is Admin */}
      </div>
    </React.Fragment>

  NewParticipantSelectionInput = () =>
    <React.Fragment>
      <p style={{ fontSize: 12 }}>{localization.get('pitches.add_users')}</p>
      <AsyncSelect
        styles={{
          menu: base => ({
            ...base,
            zIndex: 10
          })
        }}
        theme={theme => ({
          ...theme,
          borderRadius: 0
        })}
        defaultOptions
        isMulti
        value={this.state.selectedUsers}
        onChange={selectedUsers => this.setState({selectedUsers})}
        formatOptionLabel={user => (
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <img src={user.image} width={25} height={25} alt="user-image" />
            <p style={{paddingTop: 5, paddingLeft: 10}}>{user.label}</p>
          </div>
        )}
        loadOptions={inputValue => {
          let filters = [
            {column: "name", filter: inputValue},
          ]

          return request.user.getAll({filterBy: filters})
            .then(userArrays => _.concat(...userArrays).filter(user => !this.state.participants.map(participant => participant.id).concat(this.state.selectedUsers.map(user => user.id)).includes(user.id)))
            .then(users => users.map(user => ({
              value: user.id,
              label: user.name,
              image: makeFitImageUrlWithSize(user.contentCreator || user, 'xs')
            })))
            .then(users => users.sort((a, b) => a.label.localeCompare(b.label)))
        }}
      />
    </React.Fragment>

  ParticipantsDialogActions = () =>
    <React.Fragment>
      <Button onClick={() => this.props.handleClose()}>
        {localization.get('close')}
      </Button>
    </React.Fragment>

  ParticipantsDialogAddingParticipantActions = () => {

    let sendButtonDisabled;

    if (this.state.submitting) {
      sendButtonDisabled = true
    } else if (this.state.addParticipantByEmail) {
      sendButtonDisabled = !this.state.emailOfParticipantTobeAdded || !validateEmail(this.state.emailOfParticipantTobeAdded)
    }

    return (
      <React.Fragment>
        <Button disabled={this.state.submitting} onClick={() =>  this.setState({ addingParticipant: false })}>{localization.get('back')}</Button>
        <Button disabled={sendButtonDisabled} onClick={this.getAddParticipantRequest}>{localization.get('send')}</Button>
      </React.Fragment>
    )
  };

  RemoveParticipantDialog = () =>
    <Dialog open={this.state.showDeleteDialog} onBackdropClick={() => this.setState({ showDeleteDialog: false })} onEscapeKeyDown={() => this.setState({ showDeleteDialog: false })}>
      <DialogTitle>{localization.get('pitch.remove_participant_title')}</DialogTitle>
      <DialogContent>
        {this.state.participantToBeRemoved && localization.get('pitch.remove_participant_content', this.state.participantToBeRemoved.name || this.state.participantToBeRemoved.label)}
      </DialogContent>
      <DialogActions>
        <Button disabled={this.state.submitting} onClick={() => this.setState({ showDeleteDialog: false })}>{localization.get('close')}</Button>
        <Button disabled={this.state.submitting} onClick={this.requestRemoveParticipant}>{localization.get('accept')}</Button>
      </DialogActions>
    </Dialog>

  PromoteParticipantDialog = () =>
    <Dialog open={this.state.showPromotionDialog} onBackdropClick={() => this.setState({ showPromotionDialog: false })} onEscapeKeyDown={() => this.setState({ showPromotionDialog: false })}>
      <DialogTitle>
        {localization.get(this.state.promotionType === 'promote' ? 'pitch.promote_participant_title' : 'pitch.demote_participant_title')}
      </DialogTitle>
      <DialogContent>
        {this.state.participantToBePromoted &&
          localization.get(
            this.state.promotionType === 'promote' ? 'pitch.promote_participant_content' : 'pitch.demote_participant_content',
            this.state.participantToBePromoted.name)}
      </DialogContent>
      <DialogActions>
        <Button disabled={this.state.submitting} onClick={() => this.setState({ showPromotionDialog: false })}>
          {localization.get('close')}
        </Button>
        <Button disabled={this.state.submitting} onClick={this.requestPromoteParticipant}>{localization.get('send')}</Button>
      </DialogActions>
    </Dialog>

  getAddParticipantRequest = () => {
    this.setState({ submitting: true });

    const currentUsers = this.state.participants;
    const requests = this.state.selectedUsers
      .map(selectedUser => {
        currentUsers.push(selectedUser)
        return request.pitch.addParticipant(this.props.pitchId, selectedUser.value)
      })
      .concat([request.pitch.update({id: this.props.pitchId})])

    return Promise.all(requests)
      .then(() => this.setState({addingParticipant: false, selectedUsers: [], participants: currentUsers, submitting: false}))
      .catch(this.handleFailedRequest)
  }


  requestRemoveParticipant = () => {
    this.setState({ submitting: true }, () => {
      const userId = this.state.participantToBeRemoved.id || this.state.participantToBeRemoved.value;
      return request.pitch.removeParticipant(this.props.pitchId, userId)
        .then(() => this.setState({
          showDeleteDialog: false,
          selectedUsers: [],
          submitting: false,
          participants: this.state.participants.filter(user => get(user, 'id', user.value) !== userId)
        }))
        .catch(this.handleFailedRequest)
    });
  }

  requestPromoteParticipant = () => this.setState({ submitting: true }, () => {
    const userId = this.state.participantToBePromoted.id || this.state.participantToBePromoted.value;
    const req = this.state.promotionType === 'promote'
      ? request.pitch.promoteParticipant
      : request.pitch.demoteParticipant
    return req(this.props.pitchId, userId)
      .then(() => this.setState({
        showPromotionDialog: false,
        submitting: false,
        participantToBePromoted: null,
        participants: this.state.participants.map(user => {
          if(get(user, 'id', user.value) === userId) return ({...user, pivot: {is_admin: this.state.promotionType === 'promote'}})
          return user;
        })
      }))
      .catch(this.handleFailedRequest)
  });

  handleSuccessfulRequest = () => window.location.reload();

  handleFailedRequest = e => {
    if (e.status === 403) {
      GlobalSnackbar.show({ message: localization.get('pitches.action_for_admin_users'), type: GlobalSnackbarTypes.ERROR })
    } else {
      GlobalSnackbar.showGenericError()
    }
    this.setState({ submitting: false })
  }
}

export default ParticipantsButton